export const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyCprdqRJt85ElowepyaEDZM1CAWczMFjL0",
        authDomain: "sige-innovate-dev.firebaseapp.com",
        projectId: "sige-innovate-dev",
        storageBucket: "sige-innovate-dev.firebasestorage.app",
        messagingSenderId: "83459329917",
        appId: "1:83459329917:web:dcdcf79fbe71eba3224614",
        measurementId: "G-38Q6WEJJ00"
    },
    appCheck: {
        siteKey: "6Ld6RWArAAAAANi_C9MRvuRny2mH76rAQcKVYkyu"
    }
};
